<template>
    <div class="pic">
        <img @click="goBusinessClick" src="../../assets/images/zaiJiaTryv3.png">
    </div>
</template>

<script>

export default {
    name: 'zaiJiaTryInfo',
    methods: {
        goBusinessClick(){
            this.$router.push({
                path:'/zaiJiaUserInfo'
            });
        }
    }
}
</script>

<style scoped>
  @import '../../common/css/index.css';
</style>
